/* eslint-disable no-shadow */
import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    backgroundColor: '#f5f5f5',
    padding: '12px',
    textAlign: 'left',
    fontWeight: 600,
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #eee',
  },
  skeletonBox: {
    height: 16,
    borderRadius: 4,
    backgroundColor: '#e0e0e0',
    animation: '$pulse 1.5s infinite ease-in-out',
  },
  hiddenMobile: {
    display: 'table',
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  hiddenDesktop: {
    display: 'none',
    '@media (max-width: 768px)': {
      display: 'block',
    },
  },
  card: {
    borderRadius: 12,
    border: '1px solid #ddd',
    backgroundColor: '#fff',
    padding: 16,
    marginBottom: 12,
  },
  cardRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  cardLabel: {
    width: '40%',
    height: 12,
    backgroundColor: '#e0e0e0',
    borderRadius: 4,
    animation: '$pulse 1.5s infinite ease-in-out',
  },
  cardValue: {
    width: '20%',
    height: 12,
    backgroundColor: '#e0e0e0',
    borderRadius: 4,
    animation: '$pulse 1.5s infinite ease-in-out',
  },
  '@keyframes pulse': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.4 },
    '100%': { opacity: 1 },
  },
}))

export default function SkeletonTable({ isLoading }) {
  const classes = useStyles()

  if (!isLoading) return null

  return (
    <>
      <table className={`${classes.table} ${classes.hiddenMobile}`}>
        <thead>
          <tr>
            {Array(10)
              .fill(null)
              .map((_, j) => (
                <th key={j} className={classes.th} aria-label={`Encabezado ${j + 1}`}>
                  <div className={classes.skeletonBox} />
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {[...Array(5)].map((_, i) => (
            <tr key={i}>
              {Array(10)
                .fill(null)
                .map((_, j) => (
                  <td key={j} className={classes.td}>
                    <div className={classes.skeletonBox} />
                  </td>
                ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Mobile Skeleton */}
      <div className={classes.hiddenDesktop}>
        {[...Array(5)].map((_, i) => (
          <div key={i} className={classes.card}>
            <div className={classes.cardRow}>
              <div className={classes.cardLabel} />
              <div className={classes.cardValue} />
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
